import React, { useState, useEffect } from "react";
import axios from "axios";
import { Input, Radio, Row, Col, Button, DatePicker, Upload, notification, Select, Modal} from "antd";
import { CaretDownOutlined} from '@ant-design/icons';
import { Country, State} from "country-state-city";
import { get_mcm_url, get_url, get_url_params, get_v10_url } from "../utils/commonUtilities";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

import dayjs from "dayjs";

const arrow = (
  <svg width="30" height="30" viewBox="0 0 39 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.400391 20C0.400391 23.7657 1.51707 27.4469 3.60921 30.578C5.70135 33.7091 8.67499 36.1495 12.1541 37.5906C15.6332 39.0317 19.4615 39.4088 23.1549 38.6741C26.8483 37.9394 30.2409 36.1261 32.9037 33.4633C35.5665 30.8005 37.3799 27.4079 38.1145 23.7145C38.8492 20.0211 38.4721 16.1928 37.0311 12.7137C35.59 9.23456 33.1496 6.26092 30.0184 4.16878C26.8873 2.07664 23.2061 0.959961 19.4404 0.959961C14.3907 0.959961 9.54777 2.96596 5.97708 6.53665C2.40638 10.1073 0.400391 14.9502 0.400391 20ZM8.56039 18.64H25.0844L17.4956 11.0144L19.4404 9.11996L30.3204 20L19.4404 30.88L17.4956 28.9392L25.0844 21.36H8.56039V18.64Z" fill="white"/>
  </svg>
);

const uploadIcon = (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.28571 15.8655V2.8905L5.95714 6.3855L4.94571 5.3085L10 0L15.0557 5.3085L14.0443 6.387L10.7143 2.8905V15.8655H9.28571ZM2.30857 21C1.65048 21 1.10143 20.769 0.661428 20.307C0.221428 19.845 0.000952381 19.268 0 18.576V14.9415H1.42857V18.576C1.42857 18.807 1.52 19.019 1.70286 19.212C1.88571 19.405 2.08714 19.501 2.30714 19.5H17.6929C17.9119 19.5 18.1133 19.404 18.2971 19.212C18.481 19.02 18.5724 18.808 18.5714 18.576V14.9415H20V18.576C20 19.267 19.78 19.8435 19.34 20.3055C18.9 20.7675 18.3505 20.999 17.6914 21H2.30857Z" fill="#3759FF"/>
  </svg>
)
const { Option } = Select

const RegistrationForm = () => {

    const history = useHistory()

  const [registraionFormID, setRegistraionFormID] = useState('')
  const [active, setActive] = useState('1')
  const [postData, setPostData] = useState({
    userName: '',
    mobileNo: '',
    emailID: '',
    referralSource: '',
    rohiniCode: '',
    bedCount : '',
    hospitalName: '',
    hospitalAddress: '',
    state: '',
    tpaEmail: '',
    currentAccount : {
      bankName: '',
      accountNo: '',
      ifscCode: '',
      accountEmail: '',
    },
    contactPerson: '',
    contactPersonNumber: '',
    authorityName: '',
    regCertfExpiry: '',
    profileDocuments: {
      cancelledCheque: '',
      hospitalRohini: '',
      regCertificated: '',
      tarrifList: [],
      nabh: '',
    },
    nabhSpecification: '',
    handlingMember: '',
    media: {
      hospitalPhotos: [],
    }
  })

  const country = Country.getCountryByCode('IN')
  const [statesList, setStatesList] = useState([])

  const selectDate = (date) => {
    setPostData({...postData, regCertfExpiry : dayjs(date && date[0]?._d ? date[0]._d : new Date()).format('YYYY-MM-DD')})
  };
  const [validCancelCheque, setValidCancelCheque] = useState([])
  const [validRegCerti, setValidRegCerti] = useState([])
  const [validRohiniDoc, setValidRohiniDoc] = useState([])
  const [validTarrif, setValidTarrif] = useState([])
  const [hospitalPhotoList, setHospitalPhotoList] = useState([])
  const [validNabhDoc, setValidNabhDoc] = useState([])
  const [openModal, setOpenModal] = useState(false)
  
  const [memberList, setMemberList] = useState([])
  const [memberLoading, setMemberLoading] = useState(false)

  // useEffect(() => {
  //   const hsID = get_url_params('id')
  //   setRegistraionFormID(hsID)
  // },[])

  useEffect(()=> {
    const hsID = get_url_params('id')
    setRegistraionFormID(hsID)
    if(hsID === '') {
        // console.log("hsid");
        setOpenModal(true)
        return
    }
    axios.get(`${get_v10_url()}/professional/getRegistrationFormInfo?id=${hsID}`)
    .then(res => {
      if(res.data?.success) {
        if(res.data?.data?.isOpened) {
        // console.log("opened");
            setOpenModal(true)
        } else {
            setPostData({
                ...postData,
                hospitalName: res.data?.data?.hospitalName,
                mobileNo: res.data?.data?.mobileNo,
                emailID: res.data?.data?.emailID
            })
        }
      } else {
        // console.log("else");
        setOpenModal(true)
      }
    })
    .catch(err => {
      // console.log("error");
        setOpenModal(true)
      console.error('err: ', err)
    })
  },[])

  useEffect(() => {
    const state = State.getStatesOfCountry(country.isoCode)
    let stateArray = []
    if(state.length > 0) {
      state.map(item => {
        stateArray.push({
          label: item.name,
          value: item.name,
          isoCode: item.isoCode
        })
      })
    }
    setStatesList(stateArray)
  }, [])

  useEffect(() => {
    axios.get(`${get_v10_url()}/professional/getRelationshipManager`)
    .then(res => {
      setMemberLoading(true)
      if(res.status === 200) {
        setMemberLoading(false)
        let data = []
        res.data.data.map(member => {
          let obj = {
            label: member.name,
            value: member._id,
          }
          data.push(obj)
        })
        setMemberList(data)
      } else {
        setMemberLoading(false)
      }
    })
    .catch(err => {
      setMemberLoading(false)
      console.error('err: ', err)
    })
  }, [])

  const handleSelectedState = (value) => {
    setPostData({...postData, state: value})
  }

  const cancelledChequeProps = {
    name: 'file',
    action: `${get_v10_url()}/professional/uploadCancelledChequeLink?name=${postData.hospitalName}&mobileNumber=${postData.mobileNo}`,

    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    },
    beforeUpload: (file) => {
      const isPdf = file.type === 'application/pdf'
      const isLess5M = (file.size / 1024 / 1024) < 5
      if (!isPdf) {
        notification.error({
          message: 'Error',
          description: 'Please upload PDF files only'
        })
      }
      if (!isLess5M) {
        notification.error({
          message: 'Error',
          description: 'Please upload files with size less than 5 MB'
        })
      }
      return (isPdf && isLess5M);
    },
    onChange (info) {
      let newFileList = info.fileList.filter(file => {
        const isPdf = file.type === 'application/pdf';
        const isLess5M = (file.size / 1024 / 1024) < 5;
        return isPdf && isLess5M;
      });

      setValidCancelCheque(newFileList);
      if (info.file.status !== 'uploading') {
      }
      if (info.file.status === 'done') {
        const resBooking = info.file.response.data
        setPostData({...postData, profileDocuments: {...postData.profileDocuments, cancelledCheque:resBooking.docURL}})

        notification.success({
          message: 'Success',
          description: 'Successfully uploaded the file'
        })
      } else if (info.file.status === 'error') {
        setPostData({...postData, profileDocuments: {...postData?.profileDocuments, cancelledCheque:''}})

        notification.error({
          message: 'Error',
          description: "Couldn't uploaded the file"
        })
      }
    },
    onRemove(file) {
      setPostData({...postData, profileDocuments: {...postData?.profileDocuments, cancelledCheque:''}})
      setValidCancelCheque([])
    },
    maxCount: 1,
    fileList: validCancelCheque,
  }
  const registrationCertiProps = {
    name: 'file',
    action: `${get_v10_url()}/professional/uploadRegistrationCertificateLink?name=${postData.hospitalName}&mobileNumber=${postData.mobileNo}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    },
    beforeUpload: (file) => {
      const isPdf = file.type === 'application/pdf'
      const isLess5M = (file.size / 1024 / 1024) < 5
      if (!isPdf) {
        notification.error({
          message: 'Error',
          description: 'Please upload PDF files only'
        })
      }
      if (!isLess5M) {
        notification.error({
          message: 'Error',
          description: 'Please upload files with size less than 5 MB'
        })
      }
      return (isPdf && isLess5M);
    },
    onChange (info) {
      let newFileList = info.fileList.filter(file => {
        const isPdf = file.type === 'application/pdf';
        const isLess5M = (file.size / 1024 / 1024) < 5;
        return isPdf && isLess5M;
      });

      setValidRegCerti(newFileList);
      if (info.file.status !== 'uploading') {
          // console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        const resBooking = info.file.response.data
        setPostData({...postData, profileDocuments: {...postData?.profileDocuments, regCertificated:resBooking.docURL}})
        notification.success({
          message: 'Success',
          description: 'Successfully uploaded the file'
        })
      } else if (info.file.status === 'error') {
        setPostData({...postData, profileDocuments: {...postData?.profileDocuments, regCertificated:''}})
        notification.error({
          message: 'Error',
          description: "Couldn't uploaded the file"
        })
      }
    },
    onRemove(file) {
      setPostData({...postData, profileDocuments: {...postData?.profileDocuments, regCertificated:''}})
      setValidRegCerti([])
    },
    maxCount: 1,
    fileList: validRegCerti,
  }
  const hospitalRohiniProps = {
    name: 'file',
    action: `${get_v10_url()}/professional/uploadHospitalRohiniLink?name=${postData.hospitalName}&mobileNumber=${postData.mobileNo}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    },
    beforeUpload: (file) => {
      const isPdf = file.type === 'application/pdf'
      const isLess5M = (file.size / 1024 / 1024) < 5
      if (!isPdf) {
        notification.error({
          message: 'Error',
          description: 'Please upload PDF files only'
        })
      }
      if (!isLess5M) {
        notification.error({
          message: 'Error',
          description: 'Please upload files with size less than 5 MB'
        })
      }
      return (isPdf && isLess5M);
    },
    onChange (info) {
      let newFileList = info.fileList.filter(file => {
        const isPdf = file.type === 'application/pdf';
        const isLess5M = (file.size / 1024 / 1024) < 5;
        return isPdf && isLess5M;
      });

      setValidRohiniDoc(newFileList);
      if (info.file.status !== 'uploading') {
          // console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        const resBooking = info.file.response.data
        setPostData({...postData, profileDocuments: {...postData?.profileDocuments, hospitalRohini:resBooking.docURL}})
        notification.success({
          message: 'Success',
          description: 'Successfully uploaded the file'
        })
      } else if (info.file.status === 'error') {
        setPostData({...postData, profileDocuments: {...postData?.profileDocuments, hospitalRohini:''}})
        notification.error({
          message: 'Error',
          description: "Couldn't uploaded the file"
        })
      }
    },
    onRemove(file) {
      setPostData({...postData, profileDocuments: {...postData?.profileDocuments, hospitalRohini:''}})
      setValidRohiniDoc([])
    },
    maxCount: 1,
    fileList: validRohiniDoc,
  }
  const hospitalNabhProps = {
    name: 'file',
    action: `${get_v10_url()}/professional/uploadHospitalNabhLink?name=${postData.hospitalName}&mobileNumber=${postData.mobileNo}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    },
    beforeUpload: (file) => {
      const isPdf = file.type === 'application/pdf'
      const isLess5M = (file.size / 1024 / 1024) < 5
      if (!isPdf) {
        notification.error({
          message: 'Error',
          description: 'Please upload PDF files only'
        })
      }
      if (!isLess5M) {
        notification.error({
          message: 'Error',
          description: 'Please upload files with size less than 5 MB'
        })
      }
      return (isPdf && isLess5M);
    },
    onChange (info) {
      let newFileList = info.fileList.filter(file => {
        const isPdf = file.type === 'application/pdf';
        const isLess5M = (file.size / 1024 / 1024) < 5;
        return isPdf && isLess5M;
      });

      setValidNabhDoc(newFileList);
      if (info.file.status !== 'uploading') {
          // console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        const resBooking = info.file.response.data
        setPostData({...postData, profileDocuments: {...postData?.profileDocuments, nabh:resBooking.docURL}})
        notification.success({
          message: 'Success',
          description: 'Successfully uploaded the file'
        })
      } else if (info.file.status === 'error') {
        setPostData({...postData, profileDocuments: {...postData?.profileDocuments, nabh:''}})
        notification.error({
          message: 'Error',
          description: "Couldn't uploaded the file"
        })
      }
    },
    onRemove(file) {
      setPostData({...postData, profileDocuments: {...postData?.profileDocuments, nabh:''}})
      setValidNabhDoc([])
    },
    maxCount: 1,
    fileList: validNabhDoc,
  }
  const tarrifListProps = {
    name: 'file',
    action: `${get_v10_url()}/professional/uploadTarriffListLink?name=${postData.hospitalName}&mobileNumber=${postData.mobileNo}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
    beforeUpload: (file) => {
      if (postData.profileDocuments.tarrifList.length >= 10) {
        notification.error({
          message: 'Error',
          description: 'You can only upload up to 10 files.'
        });
        return false;
      }
      const isPdf = file.type === 'application/pdf';
      const isLess5M = (file.size / 1024 / 1024) < 5;
      if (!isPdf) {
        notification.error({
          message: 'Error',
          description: 'Please upload PDF files only',
        });
      }
      if (!isLess5M) {
        notification.error({
          message: 'Error',
          description: 'Please upload files with size less than 5 MB',
        });
      }
      return isPdf && isLess5M;
    },
    onChange(info) {
      let newFileList = info.fileList.filter(file => {
        const isPdf = file.type === 'application/pdf';
        const isLess5M = (file.size / 1024 / 1024) < 5;
        return isPdf && isLess5M;
      });
  
      setValidTarrif(newFileList);
  
      if (info.file.status === 'done') {
        const resBooking = info.file.response.data;
        setPostData(prevState => ({
          ...prevState,
          profileDocuments: {
            ...prevState.profileDocuments,
            tarrifList: [...prevState.profileDocuments.tarrifList, resBooking.docURL],
          }
        }));
        notification.success({
          message: 'Success',
          description: 'Successfully uploaded the file',
        });
      } else if (info.file.status === 'error') {
        notification.error({
          message: 'Error',
          description: "Couldn't upload the file",
        });
      }
    },
    onRemove(file) {
      const newTarrifList = postData.profileDocuments.tarrifList.filter(url => url !== file.response.data.docURL);
      setPostData({
        ...postData,
        profileDocuments: {
          ...postData.profileDocuments,
          tarrifList: newTarrifList, 
        },
      });
      setValidTarrif(newFileList => newFileList.filter(f => f.uid !== file.uid));
    },
    maxCount: 10, 
    fileList: validTarrif,
  };
  const hospitalPhotoProps = {
    name: 'file',
    accept: 'image/png, image/jpg, image/jpeg',
    action: `${get_v10_url()}/professional/uploadHospitalImagesLink?mobileNumber=${postData.mobileNumber}&name=${postData.hospitalName}&imageType=ABOUT_HOSPITAL`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    },
    fileList: hospitalPhotoList,
    beforeUpload: (file) => {
      if (hospitalPhotoList.length >= 10) {
        notification.error({
          message: 'Error',
          description: 'You can only upload up to 10 files.'
        });
        return false;
      }
      const isImg = ['image/png', 'image/jpg', 'image/jpeg'].includes(file.type);
      const isLess5M = (file.size / 1024 / 1024) < 5;
      if (!isImg) {
        notification.error({
          message: 'Error',
          description: 'Please upload PNG/JPG/JPEG only'
        });
      }
      if (!isLess5M) {
        notification.error({
          message: 'Error',
          description: 'Please upload files with size less than 5 MB'
        });
      }
      return isImg && isLess5M;
    },
    onChange(info) {
      let newFileList = info.fileList.filter(file => {
        const isImg = ['image/png', 'image/jpg', 'image/jpeg'].includes(file.type);
        const isLess5M = (file.size / 1024 / 1024) < 5;
        return isImg && isLess5M;
      });
  
      setHospitalPhotoList(newFileList);
  
      if (info.file.status === 'done') {
        const uploadedUrl = info.file.response.data.images[0].url; 
        if (uploadedUrl) {
          setPostData(prevData => ({
            ...prevData,
            media: {
              ...prevData.media,
              hospitalPhotos: [...prevData.media.hospitalPhotos, uploadedUrl]
            }
          }));
        }
  
        notification['success']({
          message: 'Success',
          description: 'Image uploaded successfully'
        });
      } else if (info.file.status === 'error') {
        notification['error']({
          message: 'Error',
          description: 'Image upload failed'
        });
      }
    },
    onRemove(info) {
      const updatedList = hospitalPhotoList.filter(item => item.uid !== info.uid);
      setHospitalPhotoList(updatedList);
  
      const fileUrlToRemove = info.response?.url; // Assuming you have the URL or identifier of the file to remove
      if (fileUrlToRemove) {
        setPostData(prevData => ({
          ...prevData,
          media: {
            ...prevData.media,
            hospitalPhotos: prevData.media.hospitalPhotos.filter(url => url !== fileUrlToRemove)
          }
        }));
      }
    },
  };

  const handleNext = () => {
    if(active == '1'){
      handleValidation1();
    }
    else if(active == '2'){
      handleValidation2();
    }
    else if(active == '3'){
      handleValidation3();
    }
  }
  const handleValidation1 = () =>{
    if(postData.userName === '') {
      notification.error({
        message: 'Error',
        description: 'User Name cannot be empty'
      })
      return
    }
    if(postData.mobileNo === '') {
      notification.error({
        message: 'Error',
        description: 'User Mobile cannot be empty'
      })
      return
    }
    if(postData.mobileNo!=='' && postData.mobileNo.length !== 10) {
      notification.error({
        message: 'Error',
        description: 'Please enter valid 10 digit mobile number'
      })
      return
    }
    if(postData.emailID === '') {
      notification.error({
        message: 'Error',
        description: 'User Email ID cannot be empty'
      })
      return
    }
    if(postData.emailID !== '') {
      const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if(!emailRegex.test(postData.emailID)) {
        notification.error({
          message: 'Error',
          description: 'Please enter valid email'
        })
        return
      }
    }
    if(postData.referralSource === '') {
      notification.error({
        message: 'Error',
        description: 'Reference cannot be empty'
      })
      return
    }
    if(postData.rohiniCode === '') {
      notification.error({
        message: 'Error',
        description: 'Rohini ID cannot be empty'
      })
      return
    }
    if(postData.bedCount === '') {
      notification.error({
        message: 'Error',
        description: 'Bed Count cannot be empty'
      })
      return
    }
    if(postData.hospitalName === '') {
      notification.error({
        message: 'Error',
        description: 'Hospital name cannot be empty'
      })
      return
    }
    if(postData.hospitalAddress === '') {
      notification.error({
        message: 'Error',
        description: 'Hospital address cannot be empty'
      })
      return
    }
    if(postData.state === '') {
      notification.error({
        message: 'Error',
        description: 'State cannot be empty'
      })
      return
    }
    setActive('2')
  }
  const handleValidation2 = () =>{
    if(postData.tpaEmail === '') {
      notification.error({
        message: 'Error',
        description: 'TPA Email cannot be empty'
      })
      return
    }
    if(postData.tpaEmail !== '') {
      const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if(!emailRegex.test(postData.tpaEmail)) {
        notification.error({
          message: 'Error',
          description: 'Please enter valid TPA Email'
        })
        return
      }
    }
    if(postData.currentAccount.accountEmail === '') {
      notification.error({
        message: 'Error',
        description: 'Account Email cannot be empty'
      })
      return
    }
    if(postData.currentAccount.accountEmail  !== '') {
      const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if(!emailRegex.test(postData.currentAccount.accountEmail)) {
        notification.error({
          message: 'Error',
          description: 'Please enter valid Account Email'
        })
        return
      }
    }
    if(postData.contactPerson === '') {
      notification.error({
        message: 'Error',
        description: 'Contact Person Name cannot be empty'
      })
      return
    }
    if(postData.contactPersonNumber === '') {
      notification.error({
        message: 'Error',
        description: 'Contact Person Contact cannot be empty'
      })
      return
    }
    if(postData.contactPersonNumber!=='' && postData.contactPersonNumber.length !== 10) {
      notification.error({
        message: 'Error',
        description: 'Please enter valid 10 digit Contact Person mobile number'
      })
      return
    }
    if(postData.authorityName === '') {
      notification.error({
        message: 'Error',
        description: 'Authority Signature Name cannot be empty'
      })
      return
    }
    if(postData.currentAccount.bankName === '') {
      notification.error({
        message: 'Error',
        description: 'Bank Name cannot be empty'
      })
      return
    }
    if(postData.currentAccount.accountNo === '') {
      notification.error({
        message: 'Error',
        description: 'Account Number cannot be empty'
      })
      return
    }
    if(postData.currentAccount.ifscCode === '') {
      notification.error({
        message: 'Error',
        description: 'IFSC Code cannot be empty'
      })
      return
    }
    setActive('3')
  }
  const handleValidation3 = () =>{
    if(postData.regCertfExpiry === '') {
      notification.error({
        message: 'Error',
        description: 'Registration Certificate cannot be empty'
      })
      return
    }
    if(postData.profileDocuments.cancelledCheque === '') {
      notification.error({
        message: 'Error',
        description: 'Please upload a Cancelled Cheque'
      })
      return
    }
    if(postData.profileDocuments.hospitalRohini === '') {
      notification.error({
        message: 'Error',
        description: 'Please upload a Hospital Rohini Certificate'
      })
      return
    }
    if(postData.profileDocuments.regCertificated === '') {
      notification.error({
        message: 'Error',
        description: 'Please upload a Hospital Registration Certificate'
      })
      return
    }
    if(hospitalPhotoList.length === 0) {
      notification.error({
        message: 'Error',
        description: 'Please upload at least one photo to submit'
      })
      return
    }
    submitData()
  }

  const submitData = () =>{
    if(registraionFormID === '') {
      return
    }
    const headers = {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    const body = { 
      formId: registraionFormID,
      ...postData,
    }
    axios.post(`${get_v10_url()}/professional/fillRegistrationForm`, body, {headers})
      .then(res => {
        if(res.data.success) {
          notification.success({
            message: 'Update Successful',
            description: 'Successfully updated hospital data'
          })
          // setPostData()
          history.push('/')
        } else {
          notification.error({
            message: 'Error',
            description: "Couldn't update the hospital data. Please try again later"
          })
        }
      })
      .catch(err => {
        const errMsg = err.response?.data?.message
        notification.error({
          message: 'Error',
          description: (errMsg!=='' && errMsg!==undefined && errMsg!==null) ? errMsg : "Couldn't update the hospital data. Please try again later"
        })
      })
  }
  return (
    <div className="form-page">
      <h1>Plunes Registration Form(AWC)</h1>
      {active == '1'&&(
        <>
          <h3>Please fill form correctly (attach all docs Registration, Tariff, PAN, Cheque, MOU) to process cases.</h3>
          <Row gutter={24} >
            <Col span={5}>
              <label>Name*</label>
              <Input placeholder="Enter your Name" className="edit-input" value={postData.userName || ''} onChange={e => setPostData({...postData, userName: e.target.value})}/>
            </Col>
            <Col span={5}>
              <label>Mobile*</label>
              <Input placeholder="Enter your Phone Number" className="edit-input"  value={postData.mobileNo || ''} onChange={e => setPostData({...postData, mobileNo: e.target.value})}/>
            </Col>
            <Col span={5}>
              <label>E-mail ID*</label>
              <Input placeholder="Enter your Email ID" className="edit-input" value={postData.emailID || ''} onChange={e => setPostData({...postData, emailID: e.target.value})}/>
            </Col>
          </Row>

          <Row gutter={[16, 16]}>
            <Col xs={24} md={12}>
              <div className="card">
                <div className="heading">
                  <div className="number-circle">1</div>
                  <h4>How did you come to know about Plunes?</h4>
                </div>
                <Radio.Group value={postData.referralSource || undefined} onChange={e => setPostData({...postData, referralSource: e.target.value})}>
                  <Radio value="Provider">Provider Team</Radio>
                  <Radio value="Facebook">Facebook</Radio>
                  <Radio value="Whatsapp">WhatsApp</Radio>
                </Radio.Group>
              </div>
            </Col>
            <Col xs={24} md={12}>
              <div className="card">
                <div className="heading">
                  <div className="number-circle">2</div>
                  <h4>Registration Number (Rohini ID)*</h4>
                </div>
                <p>Enter Rohini ID only, if not available put hospital registration number</p>
                <Input className="input-line" placeholder="Your Answer" value={postData.rohiniCode || ''} onChange={e => setPostData({...postData, rohiniCode: e.target.value})}/>
              </div>
            </Col>
            <Col xs={24} md={12}>
              <div className="card">
                <div className="heading">
                  <div className="number-circle">3</div>
                  <h4>Bed Count*</h4>
                </div>
                <p>Enter Bed Count</p>
                <Input className="input-line" placeholder="Your Answer" value={postData.bedCount || ''}  onChange={e => setPostData({...postData, bedCount: e.target.value})}/>
              </div>
            </Col>
            <Col xs={24} md={12}>
              <div className="card">
                <div className="heading">
                  <div className="number-circle">4</div>
                  <h4>Hospital Name*</h4>
                </div>
                <Input className="input-line" placeholder="Your Answer" value={postData.hospitalName} onChange={e => setPostData({...postData, hospitalName: e.target.value})}/>
              </div>
            </Col>
            <Col xs={24} md={12}>
              <div className="card">
                <div className="heading">
                  <div className="number-circle">5</div>
                  <h4>Hospital Address*</h4>
                </div>
                <Input className="input-line" placeholder="Your Answer" value={postData.hospitalAddress || ''} onChange={e => setPostData({...postData, hospitalAddress: e.target.value})}/>
              </div>
            </Col>
            <Col xs={24} md={12}>
              <div className="card">
                <div className="heading">
                  <div className="number-circle">6</div>
                  <h4>State*</h4>
                </div>
                {statesList && <Select suffixIcon={<CaretDownOutlined style={{color:'#000000'}}/>} className="input-select" placeholder='Select State-'
                  value={postData.state || undefined}
                  isMulti={false}
                  onChange={handleSelectedState}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  filterSort={(opA, opB) => 
                    (opA?.label ?? '').toLowerCase().localeCompare((opB?.label ?? '').toLowerCase())
                  }
                  getPopupContainer={trigger => trigger.parentElement}
                >
                  {statesList.map(state => (
                    <Select.Option value={state.value} isoCode={state.isoCode}>
                      {state.label}
                    </Select.Option>
                  ))}
                </Select>}
              </div>
            </Col>
          </Row>
          <div className="footer-button active">
            <Button onClick={handleNext} className="button" >
              Next
              {arrow}
            </Button>
          </div>
        </>
      )}
      {active == '2'&&(
        <>
          <Row gutter={[16, 16]} style={{marginTop: '5rem'}}>
            <Col xs={24} md={12}>
              <div className="card">
                <div className="heading">
                  <div className="number-circle">7</div>
                  <h4>TPA Email Address*</h4>
                </div>
                <Input className="input-line" placeholder="Your Answer" value={postData.tpaEmail || ''} onChange={e => setPostData({...postData, tpaEmail:e.target.value})}/>
              </div>
            </Col>
            <Col xs={24} md={12}>
              <div className="card">
                <div className="heading">
                  <div className="number-circle">8</div>
                  <h4>Account’s Email Address*</h4>
                </div>
                <Input className="input-line" placeholder="Your Answer" value={postData.currentAccount.accountEmail || ''} onChange={e => setPostData({...postData, currentAccount: { ...postData.currentAccount, accountEmail: e.target.value },})} />
              </div>
            </Col>
            <Col xs={24} md={12}>
              <div className="card">
                <div className="heading">
                  <div className="number-circle">9</div>
                  <h4>Contact Person Name*</h4>
                </div>
                <Input className="input-line" placeholder="Your Answer" value={postData.contactPerson || ''} onChange={e => setPostData({...postData, contactPerson: e.target.value})}/>
              </div>
            </Col>
            <Col xs={24} md={12}>
              <div className="card">
                <div className="heading">
                  <div className="number-circle">10</div>
                  <h4>Contact Person Number*</h4>
                </div>
                <Input className="input-line" placeholder="Your Answer" value={postData.contactPersonNumber || ''} onChange={e => setPostData({...postData,  contactPersonNumber: e.target.value})}/>
              </div>
            </Col>
            <Col xs={24} md={12}>
              <div className="card">
                <div className="heading">
                  <div className="number-circle">11</div>
                  <h4>MOU Signing Authority Name*</h4>
                </div>
                <Input className="input-line" placeholder="Your Answer" value={postData.authorityName || ''} onChange={e => setPostData({...postData, authorityName:e.target.value})}/>
              </div>
            </Col>
            <Col xs={24} md={12}>
              <div className="card">
                <div className="heading">
                  <div className="number-circle">12</div>
                  <h4>Bank Name*</h4>
                </div>
                <Input className="input-line" placeholder="Your Answer" value={postData.currentAccount.bankName || ''} onChange={e => setPostData({ ...postData, currentAccount: { ...postData.currentAccount, bankName: e.target.value }})}/>
              </div>
            </Col>
            <Col xs={24} md={12}>
              <div className="card">
                <div className="heading">
                  <div className="number-circle">13</div>
                  <h4>Account Number*</h4>
                </div>
                <Input className="input-line" placeholder="Your Answer" value={postData.currentAccount.accountNo || ''} onChange={e => setPostData({ ...postData, currentAccount: { ...postData.currentAccount, accountNo: e.target.value }})}/>
              </div>
            </Col>
            <Col xs={24} md={12}>
              <div className="card">
                <div className="heading">
                  <div className="number-circle">14</div>
                  <h4>IFSC Code*</h4>
                </div>
                <Input className="input-line" placeholder="Your Answer" value={postData.currentAccount.ifscCode || ''} onChange={e => setPostData({ ...postData, currentAccount: { ...postData.currentAccount, ifscCode: e.target.value }})}/>
              </div>
            </Col>
          </Row>
          <div className="footer-button">
            <Button onClick={() => setActive('1')} className="button" >
              Back
            </Button>
            <Button onClick={handleNext} className="button" >
              Next
              {arrow}
            </Button>
          </div>
        </>
      )}
      {active == '3'&&(
        <>
          <Row gutter={[16, 16]} style={{marginTop: '5rem'}}>
            <Col xs={24} md={12}>
              <div className="card">
                <div className="heading">
                  <div className="number-circle">15</div>
                  <h4>Hospital Registration Certificate Expiry Date*</h4>
                </div>
                <p>Date</p>
                <DatePicker style={{minHeight:'45px'}} className="datePicker" onChange={selectDate} format={'DD-MMM-YYYY'}/>
              </div>
            </Col>
            <Col xs={24} md={12}>
              <div className="card">
                <div className="heading">
                  <div className="number-circle">16</div>
                  <h4>Cancelled Cheque*</h4>
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                  <p>Upload 1 Supported file. Max 5 MB.</p>
                  <Upload {...cancelledChequeProps} className="upload-container">
                    <div className="upload-form-container">
                      {uploadIcon}
                      <p>Add Files</p>
                    </div>
                  </Upload>
                </div>
              </div>
            </Col>
            <Col xs={24} md={12}>
              <div className="card">
                <div className="heading">
                  <div className="number-circle">17</div>
                  <h4>Hospital Registration Certificate*</h4>
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                  <p>Upload 1 Supported file. Max 5 MB.</p>
                  <Upload {...registrationCertiProps} className="upload-container">
                    <div className="upload-form-container">
                      {uploadIcon}
                      <p>Add Files</p>
                    </div>
                  </Upload>
                </div>
              </div>
            </Col>
            <Col xs={24} md={12}>
              <div className="card">
                <div className="heading">
                  <div className="number-circle">18</div>
                  <h4>Rohini Certificate*</h4>
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                  <p>Upload 1 Supported file. Max 5 MB.</p>
                  <Upload {...hospitalRohiniProps} className="upload-container">
                    <div className="upload-form-container">
                      {uploadIcon}
                      <p>Add Files</p>
                    </div>
                  </Upload>
                </div>
              </div>
            </Col>
            <Col xs={24} md={12}>
              <div className="card">
                <div className="heading">
                  <div className="number-circle">19</div>
                  <h4>NABH (Optional )</h4>
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                  <div>
                    <p>If you select yes then specify the level and upload the file.</p>
                    <p>Upload 1 Supported file. Max 5 MB.</p>
                  </div>
                  <Upload {...hospitalNabhProps} className="upload-container">
                    <div className="upload-form-container">
                      {uploadIcon}
                      <p>Add Files</p>
                    </div>
                  </Upload>
                </div>
                <Input className="input-line" value={postData.nabhSpecification} onChange={e => setPostData({...postData, nabhSpecification: e.target.value})} placeholder="Specify" />

              </div>
            </Col>
            <Col xs={24} md={12}>
              <div className="card">
                <div className="heading">
                  <div className="number-circle">20</div>
                  <h4>Hospital Infrastructure*</h4>
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                  <div>
                    <p style={{color: 'black', fontWeight: '600'}}>*mandatory* Please add Hospital Photos (front, entrance, OT, reception, rooms),</p>
                    <p>Upload up to 10 Supported files. Max 5 MB.</p>
                  </div>
                  <Upload {...hospitalPhotoProps} className="upload-container" maxCount={10}>
                    <div className="upload-form-container">
                      {uploadIcon}
                      <p>Add Files</p>
                    </div>
                  </Upload>
                </div>
              </div>
            </Col>
            <Col xs={24} md={12}>
              <div className="card">
                <div className="heading">
                  <div className="number-circle">21</div>
                  <h4>Hospital Tarrif*</h4>
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                  <div>
                    <p style={{fontWeight: '600'}}>Please attach GIPSA or TPA/Insurance Package Rate list. If not attach Hospital Tariff</p>
                    <p>Upload upto 10 Supported file. Max 5 MB.</p>
                  </div>
                  <Upload {...tarrifListProps} className="upload-container" maxCount={10}>
                    <div className="upload-form-container">
                      {uploadIcon}
                      <p>Add Files</p>
                    </div>
                  </Upload>
                </div>
              </div>
            </Col>
            <Col xs={24} md={12}>
              <div className="card">
                <div className="heading">
                  <div className="number-circle">22</div>
                  <h4>Relationship Manager*</h4>
                </div>
                <Select
                  suffixIcon={<CaretDownOutlined 
                  style={{color:'#000000'}}/>} 
                  className="input-select"
                  placeholder='Select Member'
                  value={postData.handlingMember || undefined}
                  onChange={e => setPostData({...postData, handlingMember: e})}
                >
                {memberList.map((member, idx) => (
                  <Option value={member.value} key={idx}>
                    {member.label}
                  </Option>
                ))}
                </Select>
              </div>
            </Col>
          </Row>
          <div className="footer-button">
            <Button onClick={() => setActive('2')} className="button" >
              Back
            </Button>
            <Button onClick={handleNext} className="button" >
              Submit
            </Button>
          </div>
        </>
      )}
      <Modal
        width={"500px"}
        open={openModal}
        onOk={()=>{}}
        onCancel={()=>{}}
        title={""}
        className="already-submitted-modal"
      >
        <h5>
            Form is either already submitted or the link is expired. <br/>
            Return to Sign-in/Home page.
        </h5>
        <div className="btn-cont">
            <Button className="btn" onClick={()=>{history.push('/auth')}} >Sign in</Button>
            <Button className="btn primary" onClick={()=>{history.push('/')}} >Home</Button>
        </div>
      </Modal>
    </div>
  );
};

export default RegistrationForm;
